import { selectAvailableViews } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useAvailableViews = () => useSelector(selectAvailableViews);

export default useAvailableViews;
